import React, { ReactElement, ReactNode, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import Layout from '@common/layout';
import AllianceModal from '@components/common/modals/affiliateModal/affiliateList';
import Header from '@components/common/header';
import Modal from '@components/common/modal';
import { getAccessToken } from '@repository/AccessToken';
import { useUserInfo } from '@repository/auth/useUserInfo';
import { ContentRouteUtil } from '@utils/routeUtil';
import useCheckAuthority from '@utils/hooks/useCheckAuthority';
import classNames from 'classnames/bind';
import styles from './noAffiliateAuthModal.module.scss';

const cx = classNames.bind(styles);

interface NoAffiliateAuthWrapProps {
  title: string | ReactNode;
  children?: ReactElement | string;
}

/**제휴 & 이벤트 인증만 체크 */
const NoAffiliateAuthWrap = ({ title, children }: NoAffiliateAuthWrapProps) => {
  const { data: userData } = useUserInfo();
  const isLogin = !!userData?.id;
  const { isEventUser, isAuthorityUser } = useCheckAuthority(userData);

  const [allianceModalVisible, setAllianceModalVisible] = useState(false);
  const router = useRouter();

  const goMyPagePremiumPage = () => {
    ContentRouteUtil.goMyPage('premium');
  };

  useEffect(() => {
    if (!router.isReady) return;
    if (!getAccessToken()) ContentRouteUtil.goLoginPage(router.pathname);
  }, [router]);

  if (!isLogin) return null;
  if (isLogin && (isEventUser || isAuthorityUser)) return <>{children}</>;

  return (
    <Layout>
      <Header />
      <Modal visible={true}>
        <div className={cx('affiliateAuthWrap')}>
          <div className={cx('layerModal')}>
            <strong className={cx('title')}>{title}</strong>
            <div className={cx('btnArea')}>
              <a className={cx('btn', 'certification')} role="button" onClick={goMyPagePremiumPage}>
                제휴 대학 및 인증 코드 입력하기
              </a>
              <a className={cx('btn', 'list')} role="button" onClick={() => setAllianceModalVisible(true)}>
                제휴 리스트 확인하기
              </a>
            </div>
          </div>
          <AllianceModal visible={allianceModalVisible} onClose={() => setAllianceModalVisible(false)} />
        </div>
      </Modal>
    </Layout>
  );
};

export default NoAffiliateAuthWrap;
